// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_textarea__\\+Hpr- {\n    height: 120px;\n    padding: 15px;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/Common/Forms/Textarea/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;AACjB","sourcesContent":[".textarea {\n    height: 120px;\n    padding: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea": "styles_textarea__+Hpr-"
};
export default ___CSS_LOADER_EXPORT___;
